/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_2_Title_Ver2Inputs */

const en_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just a Few Steps Away`)
};

const ar_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بقيت خطوات قليلة فقط`)
};

const de_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur noch wenige Schritte`)
};

const es_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A solo unos pasos`)
};

const fr_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus que quelques étapes`)
};

const it_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mancano solo pochi passi`)
};

const ja_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あと少しです！`)
};

const ko_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`거의 다 왔어요!`)
};

const pt_br_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A poucos passos de distância`)
};

const ru_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Осталось всего несколько шагов`)
};

const th_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีกเพียงไม่กี่ก้าว`)
};

const tr_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sadece Birkaç Adım Kaldı`)
};

const zh_cn_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只差一点！`)
};

const zh_tw_starter_challenge_phase_2_title_ver2 = /** @type {(inputs: Starter_Challenge_Phase_2_Title_Ver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只差一點！`)
};

/**
* | output |
* | --- |
* | "Just a Few Steps Away" |
*
* @param {Starter_Challenge_Phase_2_Title_Ver2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_2_title_ver2 = /** @type {((inputs?: Starter_Challenge_Phase_2_Title_Ver2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_2_Title_Ver2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "de") return de_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "es") return es_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "it") return it_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "th") return th_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_2_title_ver2(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_2_title_ver2(inputs)
	return zh_tw_starter_challenge_phase_2_title_ver2(inputs)
});